/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_EmptyInputs */

const en_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No posts published yet.`)
};

const es_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay publicaciones.`)
};

const de_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Beiträge veröffentlicht.`)
};

const zh_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未发布帖子。`)
};

const ar_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد منشورات بعد.`)
};

const fr_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun article publié pour l'instant.`)
};

const vi_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có bài nào được đăng.`)
};

const sw_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bado hakuna machapisho yaliyochapishwa.`)
};

const th_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีการเผยแพร่โพสต์`)
};

const bs_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Još nema objavljenih postova.`)
};

const ja_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投稿はまだありません。`)
};

const ko_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 게시물이 없습니다.`)
};

const pt_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma publicação ainda.`)
};

const it_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun post pubblicato.`)
};

const sv_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga inlägg publicerade ännu.`)
};

const nl_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen berichten gepubliceerd.`)
};

const da_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endnu ikke offentliggjort.`)
};

const nb_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen innlegg publisert ennå.`)
};

const fi_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toimia ei ole vielä julkaistu.`)
};

const pl_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie opublikowano jeszcze żadnych postów.`)
};

const ru_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет опубликованных постов.`)
};

const tr_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz yayınlanan yazı yok.`)
};

const hi_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक प्रकाशित नहीं किया गया है।`)
};

const id_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada posting yang diterbitkan.`)
};

const ms_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada hantaran yang diterbitkan.`)
};

const cs_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosud nezveřejněné žádné příspěvky.`)
};

const el_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν έχουν δημοσιευθεί ακόμα δημοσιεύσεις.`)
};

const he_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עדיין לא פורסמו פוסטים.`)
};

const af_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen plasings is gepubliseer nie.`)
};

const hu_blog_empty = /** @type {(inputs: Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Még nem tették közzé.`)
};

/**
* | output |
* | --- |
* | "No posts published yet." |
*
* @param {Blog_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_empty = /** @type {((inputs?: Blog_EmptyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_EmptyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_empty(inputs)
	if (locale === "de") return de_blog_empty(inputs)
	if (locale === "zh") return zh_blog_empty(inputs)
	if (locale === "ar") return ar_blog_empty(inputs)
	if (locale === "fr") return fr_blog_empty(inputs)
	if (locale === "vi") return vi_blog_empty(inputs)
	if (locale === "sw") return sw_blog_empty(inputs)
	if (locale === "th") return th_blog_empty(inputs)
	if (locale === "bs") return bs_blog_empty(inputs)
	if (locale === "ja") return ja_blog_empty(inputs)
	if (locale === "ko") return ko_blog_empty(inputs)
	if (locale === "pt") return pt_blog_empty(inputs)
	if (locale === "it") return it_blog_empty(inputs)
	if (locale === "sv") return sv_blog_empty(inputs)
	if (locale === "nl") return nl_blog_empty(inputs)
	if (locale === "da") return da_blog_empty(inputs)
	if (locale === "nb") return nb_blog_empty(inputs)
	if (locale === "fi") return fi_blog_empty(inputs)
	if (locale === "pl") return pl_blog_empty(inputs)
	if (locale === "ru") return ru_blog_empty(inputs)
	if (locale === "tr") return tr_blog_empty(inputs)
	if (locale === "hi") return hi_blog_empty(inputs)
	if (locale === "id") return id_blog_empty(inputs)
	if (locale === "ms") return ms_blog_empty(inputs)
	if (locale === "cs") return cs_blog_empty(inputs)
	if (locale === "el") return el_blog_empty(inputs)
	if (locale === "he") return he_blog_empty(inputs)
	if (locale === "af") return af_blog_empty(inputs)
	if (locale === "hu") return hu_blog_empty(inputs)
	return en_blog_empty(inputs)
});